<template>
  <div class="car-life" :class="isMobile ? '' : 'fill-section-1080'">
    <img class="img-cover" :src="bgImg" alt="METTA" />
    <div class="car-life-content fade-up">
      <h5 v-if="!isMobile">
        METTA<br>硬派越野生活方式系列
      </h5>
      <h5 v-else class="mobile-title">
        <span>METTA</span>
        <span>硬派越野</span>
        <span>生活方式系列</span>
      </h5>
      <p v-if="!isMobile">
        我们提供从日常到极致的全场景越野体验<br>
        帮助每一位越野爱好者——向外探索，向内抵达
      </p>
      <p v-else class="mobile-desc">
        <span>我们提供从日常到极致的</span>
        <span>全场景越野体验</span>
        <span>帮助每一位越野爱好者</span>
        <span>一一向外探索，向内抵达</span>
      </p>
      <div class="car-life-btns">
        <button class="btn-white" @click="$router.push( { path: '/', query: { scrollTo: 'share-plan' } })">进入社区 →</button>
        <button class="btn-ghost-wh" @click="$router.push({ path: '/', query: { scrollTo: 'car-series' } })">进入载具库</button>
      </div>
    </div>
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  name: 'CarLifeComponent',
  props: {
    bgImg: {
      type: String,
      required: true
    },
  },
  mounted() {
    fadeAnimate();
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    window.removeEventListener('resize', this.checkDevice)
  },
  // computed: {
  //   bgImg() {
  //     return this.isMobile ? 'm-car-life-bg.jpg' : 'car-life-bg.jpg'
  //   },
  // },
  data() {
    return {
      isMobile: false,
      // imgUrlPrefix: '/assets/images/',
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
  }
}
</script>

<style lang="less" scoped>
.car-life {
  .car-life-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h5 {
      font-weight: @fw1;
      font-size: clamp(32px, 2.5vw, 48px);
      color: #ffffff;
      text-align: center;
    }
    p {
      margin-top: 0.83vw;
      font-weight: @fw2;
      font-size: clamp(16px, 1.25vw, 24px);
      color: rgba(255, 255, 255, 0.5);
      text-align: center;
    }
    .car-life-btns {
      display: flex; gap: 16px; justify-content: center; margin-top: 14vw;
      .btn-white {
        font-size: clamp(12px, 0.83vw, 16px);
        color: @ink; background: white; border: 1px solid white;
        padding: 10px 20px; font-family: inherit; font-weight: @fw2; cursor: pointer;
        transition: opacity .15s;
        &:hover { opacity: .85; }
      }
      .btn-ghost-wh {
        font-size: clamp(12px, 0.83vw, 16px);
        color: white; background: transparent;
        border: 1px solid rgba(255,255,255,0.2);
        padding: 10px 25px; font-family: inherit; font-weight: @fw2; cursor: pointer;
        transition: border-color .15s;
        &:hover { border-color: rgba(255,255,255,0.5); }
      }
    }

  }
}
@media (max-width: @mobile-width) {
  .car-life {
    position: relative;

    .car-life-content {
      inset: 0;
      transform: none;

      display: flex;
      flex-direction: column;
      align-items: center;

      padding-top: 56vw;
      box-sizing: border-box;
      text-align: center;
    }

    .mobile-title {
      width: 100%;
      margin: 0;

      span {
        display: block;
        font-size: 7.2vw;
        line-height: 1.22;
        font-weight: @fw1;
        color: #fff;
        white-space: nowrap;
      }
    }

    .mobile-desc {
      width: 100%;
      margin-top: 4.8vw;

      span {
        display: block;
        font-size: 3.6vw;
        line-height: 1.7;
        font-weight: @fw2;
        color: rgba(255, 255, 255, 0.75);
        white-space: nowrap;
      }
    }

    .car-life-btns {
      display: flex;
      justify-content: center;
      gap: 5.33vw;
      margin-top: 8vw;

      .btn-white,
      .btn-ghost-wh {
        width: 34vw;
        height: 10.67vw;
        padding: 0;
        font-size: 3.73vw;
        white-space: nowrap;
      }
    }
  }
}
</style>